function i(e) {
  const a = [
    "assembly",
    "module",
    "package",
    "import",
    "alias",
    "class",
    "interface",
    "object",
    "given",
    "value",
    "assign",
    "void",
    "function",
    "new",
    "of",
    "extends",
    "satisfies",
    "abstracts",
    "in",
    "out",
    "return",
    "break",
    "continue",
    "throw",
    "assert",
    "dynamic",
    "if",
    "else",
    "switch",
    "case",
    "for",
    "while",
    "try",
    "catch",
    "finally",
    "then",
    "let",
    "this",
    "outer",
    "super",
    "is",
    "exists",
    "nonempty"
  ], t = [
    "shared",
    "abstract",
    "formal",
    "default",
    "actual",
    "variable",
    "late",
    "native",
    "deprecated",
    "final",
    "sealed",
    "annotation",
    "suppressWarnings",
    "small"
  ], c = [
    "doc",
    "by",
    "license",
    "see",
    "throws",
    "tagged"
  ], n = {
    className: "subst",
    excludeBegin: !0,
    excludeEnd: !0,
    begin: /``/,
    end: /``/,
    keywords: a,
    relevance: 10
  }, s = [
    {
      // verbatim string
      className: "string",
      begin: '"""',
      end: '"""',
      relevance: 10
    },
    {
      // string literal or template
      className: "string",
      begin: '"',
      end: '"',
      contains: [n]
    },
    {
      // character literal
      className: "string",
      begin: "'",
      end: "'"
    },
    {
      // numeric literal
      className: "number",
      begin: "#[0-9a-fA-F_]+|\\$[01_]+|[0-9_]+(?:\\.[0-9_](?:[eE][+-]?\\d+)?)?[kMGTPmunpf]?",
      relevance: 0
    }
  ];
  return n.contains = s, {
    name: "Ceylon",
    keywords: {
      keyword: a.concat(t),
      meta: c
    },
    illegal: "\\$[^01]|#[^0-9a-fA-F]",
    contains: [
      e.C_LINE_COMMENT_MODE,
      e.COMMENT("/\\*", "\\*/", { contains: ["self"] }),
      {
        // compiler annotation
        className: "meta",
        begin: '@[a-z]\\w*(?::"[^"]*")?'
      }
    ].concat(s)
  };
}
export {
  i as default
};
